export default __webpack_public_path__ + "static/media/icon_ui_warning.f55d1dcb.png";